import React from 'react'
import { List, Stack } from '@mui/material'
import { TokenListItem } from './TokenListItem'
import {
  GroupedBalance,
  TokenBalance,
  tokenBalanceToBalanceGroup,
} from '@plug-core/providers/BalanceProvider'

interface IProps {
  balances: GroupedBalance[] | TokenBalance[]
  onTokenClick?: (canisterId: TokenBalance) => void
  showPriceChange: boolean
}

export const TokenList = ({ balances, onTokenClick, showPriceChange }: IProps) => {
  return (
    <Stack component={List} disablePadding>
      {balances.map((balance, i) => (
        <TokenListItem
          key={i}
          balance={balance}
          onClick={onTokenClick}
          showPriceChange={showPriceChange}
        />
      ))}
    </Stack>
  )
}
